<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Seguimiento de obras</h2></v-toolbar-title></pre>
        </v-toolbar>

        <v-card-text>
            <v-btn class="white--text" color="blue" :to="'/calendario-orden'"
                >Calendario</v-btn
            >
            <br />

            <v-data-table
                dense
                :headers="headers"
                :items="items"
                :items-per-page="15"
                item-key="id"
                class="elevation-0 mt-4"
                :sort-by="['created_at']"
                :sort-desc="[false]"
            >
                <template v-slot:item.pdf="{ item }">
                    <a
                        target="_blank"
                        :href="`/api/pdf-orden/${item.id}`"
                        @click.stop=""
                    >
                        <v-icon
                            small
                            class="mr-2"
                            color="red"
                            style="font-size: 25px"
                            title="PDF"
                            >mdi-pdf-box</v-icon
                        >
                    </a>
                </template>
                <template v-slot:item.fecha_prevista="{ item }">
                    <span>{{ item.fecha_prevista | format_date }}</span>
                </template>
                <template v-slot:item.created_at="{ item }">
                    <span>{{ item.created_at | format_date }}</span>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    data() {
        return {
            headers: [
                {
                    text: "Nº Obra",
                    value: "nro_orden",
                    sortable: false,
                },
                {
                    text: "Nº Obra relacionada",
                    value: "orden_relacionada",
                    sortable: false,
                },
                {
                    text: "Fecha",
                    value: "created_at",
                    sortable: false,
                },
                {
                    text: "Fecha prevista",
                    value: "fecha_prevista",
                    sortable: false,
                },
                {
                    text: "Instalación eléctrica",
                    value: "instalacion_electrica",
                    sortable: false,
                },
                {
                    text: "PDF",
                    value: "pdf",
                    sortable: false,
                },
                {
                    text: "Acciones",
                    value: "action",
                    sortable: false,
                },
            ],
            items: [],
        };
    },
    created() {
        this.getOrdenes();
    },
    methods: {
        getOrdenes() {
            axios.get(`api/get-seguimiento-orden-trabajo`).then(
                (res) => {
                    this.items = res.data;
                },
                (err) => {
                    this.$custom_error("Error consultando la obra");
                }
            );
        },
    },
    computed: {
        isloading: function () {
            return this.$store.getters.getloading;
        },
    },
};
</script>
